(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!window.Shopify?.designMode) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        this.isDesktop = window.matchMedia('(min-width: 990px)').matches;
        this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
        this.onMediaChange = this.onMediaChange.bind(this);
        this.desktopMediaQuery.addEventListener('change', this.onMediaChange);

        if (document.readyState !== 'complete') {
          window.addEventListener('load', () => this.setHeaderHeight(), { once: true });
        }

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();

        /* ── Intro-Phase (homepage, desktop, single-instance) ───────────── */
        const isHomePage =
          document.body.classList.contains('homepage-intro-phase') ||
          window.location.pathname === '/' ||
          /^\/[a-z]{2}(-[a-z]{2})?\/?$/.test(window.location.pathname);

        if (
          isHomePage &&
          this.isDesktop &&
          !this.headerIsAlwaysSticky &&
          !window.__kasaIntroOwner
        ) {
          this._claimIntro();
        }

        /* bfcache restore: pageshow handler sets __kasaIntroRestart.
           Pick it up here in case connectedCallback already ran (element
           is still in DOM). Also listen for future restores. */
        if (window.__kasaIntroRestart && !window.__kasaIntroOwner && this.isDesktop && !this.headerIsAlwaysSticky) {
          window.__kasaIntroRestart = false;
          this._claimIntro();
        }
        this._onPageShow = (e) => {
          if (!e.persisted) return;
          /* The pageshow handler in theme.liquid re-adds the class and
             sets __kasaIntroRestart. By the time this fires the class is
             already on <body>, so we just claim + restart. */
          if (window.__kasaIntroRestart && !window.__kasaIntroOwner && this.isDesktop && !this.headerIsAlwaysSticky) {
            window.__kasaIntroRestart = false;
            this._claimIntro();
          }
        };
        window.addEventListener('pageshow', this._onPageShow);
      }

      _claimIntro() {
        window.__kasaIntroOwner = this;
        // Collect ALL header-group sections (announcement bar + header section).
        this.headerGroupEls = Array.from(document.querySelectorAll('.shopify-section-group-header-group'));
        this.mainContent = document.querySelector('.content-for-layout');

        // Set --kasa-pull synchronously right now so CSS has the correct value
        // from the very first paint. Re-measure after fonts load for accuracy.
        const measureAndSet = () => {
          const totalH = this.headerGroupEls.reduce((s, el) => s + (el ? el.offsetHeight : 0), 0);
          if (totalH > 0) {
            document.documentElement.style.setProperty('--kasa-pull', (-totalH) + 'px');
          }
        };
        measureAndSet(); // synchronous: DOM is ready, headers are in DOM
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => requestAnimationFrame(measureAndSet));
        }

        // Clear any lingering inline styles from a previous run.
        if (this.mainContent) {
          this.mainContent.style.transform = '';
          this.mainContent.style.transition = '';
        }
        this.headerGroupEls.forEach(el => {
          if (el) { el.style.transform = ''; el.style.transition = ''; }
        });

        // Reset Dawn sticky classes so they don't interfere.
        if (this.header) {
          this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }
        this.currentScrollTop = 0;
        // Reveal after 5 seconds.
        clearTimeout(this.revealTimeoutId);
        this.revealTimeoutId = setTimeout(() => this._endIntroPhase(), 5000);
      }

      onMediaChange(e) {
        this.isDesktop = e.matches;
        if (!e.matches && window.__kasaIntroOwner === this) {
          clearTimeout(this.revealTimeoutId);
          this.revealTimeoutId = null;
          window.__kasaIntroOwner = null;
          this._introCleanup();
        }
      }

      _endIntroPhase() {
        if (window.__kasaIntroOwner !== this) return;
        window.__kasaIntroOwner = null;

        clearTimeout(this.revealTimeoutId);
        this.revealTimeoutId = null;

        if (!document.body.classList.contains('homepage-intro-phase')) {
          this._introCleanup();
          return;
        }

        // Force layout so browser records pre-transition state.
        if (this.headerGroupEls && this.headerGroupEls[0]) {
          this.headerGroupEls[0].getBoundingClientRect();
        }

        // Switch to Phase 2: keep homepage-intro-phase (so the transform source
        // state is still defined), ADD intro-revealing (which overrides transform
        // to translateY(0) with a transition).  The browser animates from the
        // current computed -200vh → 0 for headers, and from --kasa-pull → 0 for content.
        document.body.classList.add('intro-revealing');

        // After the transition finishes (0.55s), atomically swap to normal flow.
        setTimeout(() => {
          this._introCleanup();
        }, 600);
      }

      _introCleanup() {
        // Atomic swap: remove both intro classes in the same frame.
        // Since all elements are now at translateY(0) (end of Phase 2 transition),
        // removing the classes just removes the transition rules — no visual jump.
        //
        // Step 1: suppress transitions so the class removal is instantaneous.
        if (this.mainContent) this.mainContent.style.transition = 'none';
        (this.headerGroupEls || []).forEach(el => {
          if (el) el.style.transition = 'none';
        });

        // Step 2: remove intro classes, clear CSS variable and inline styles.
        document.body.classList.remove('homepage-intro-phase', 'intro-revealing');
        document.documentElement.style.removeProperty('--kasa-pull');
        if (this.mainContent) this.mainContent.style.transform = '';

        // Step 3: clear the inline transition overrides in the next microtask
        // so the browser can re-enable transitions for normal page interactions.
        requestAnimationFrame(() => {
          if (this.mainContent) this.mainContent.style.transition = '';
          (this.headerGroupEls || []).forEach(el => {
            if (el) el.style.transition = '';
          });
        });

        // Reinitialise Dawn sticky system in the next frame.
        if (this.header) {
          if (!this.headerIsAlwaysSticky) {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            requestAnimationFrame(() => {
              this.header.classList.add('shopify-section-header-sticky');
              this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
              this.createObserver();
            });
          } else {
            requestAnimationFrame(() => this.createObserver());
          }
        }
      }

      setHeaderHeight() {
        /*
         * FIX: Measure the inner <header> element (header-wrapper), NOT
         * .section-header. The section wrapper contains @app blocks from
         * Swym and other apps; their injected DOM can temporarily inflate
         * .section-header.offsetHeight to incorrect values (e.g. 341px).
         *
         * The <header> tag inside sticky-header only contains nav/logo and
         * is immune to app-block injection, giving a stable, correct height.
         *
         * We also attach a ResizeObserver so --header-height stays accurate
         * after any async mutations (font load, app injection, viewport resize).
         */
        const innerHeader = this.querySelector('header') || this.header;

        const writeHeight = () => {
          document.documentElement.style.setProperty(
            '--header-height',
            `${innerHeader.offsetHeight}px`
          );
        };

        // Disconnect any previous observer to avoid leaks on re-init.
        if (this._headerResizeObserver) {
          this._headerResizeObserver.disconnect();
          this._headerResizeObserver = null;
        }

        if (typeof ResizeObserver !== 'undefined') {
          // ResizeObserver fires on initial observe + every subsequent resize.
          this._headerResizeObserver = new ResizeObserver(() => {
            requestAnimationFrame(writeHeight);
          });
          this._headerResizeObserver.observe(innerHeader);
        } else {
          // Fallback for very old browsers: one-shot measurement after fonts.
          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => requestAnimationFrame(writeHeight));
          } else {
            requestAnimationFrame(writeHeight);
          }
        }
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        if (this._onPageShow) {
          window.removeEventListener('pageshow', this._onPageShow);
        }
        if (this.desktopMediaQuery) {
          this.desktopMediaQuery.removeEventListener('change', this.onMediaChange);
        }
        clearTimeout(this.revealTimeoutId);

        if (this._headerResizeObserver) {
          this._headerResizeObserver.disconnect();
          this._headerResizeObserver = null;
        }

        if (window.__kasaIntroOwner === this) {
          window.__kasaIntroOwner = null;
          this._introCleanup();
        }
      }

      createObserver() {
        this.headerBounds = {};
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Intro still active: trigger reveal on first scroll-up.
        if (window.__kasaIntroOwner === this && this.isDesktop && !this.headerIsAlwaysSticky) {
          if (scrollTop < this.currentScrollTop) {
            this._endIntroPhase();
          }
          this.currentScrollTop = scrollTop;
          return;
        }

        // Wait for IntersectionObserver after intro cleanup.
        const boundsBottom = this.headerBounds && this.headerBounds.bottom;
        if (boundsBottom == null) {
          this.currentScrollTop = scrollTop;
          return;
        }

        if (scrollTop > this.currentScrollTop && scrollTop > boundsBottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > boundsBottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach((disclosure) => disclosure.close());
      }

      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
